import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";
import Footer from "../component/Footer";
import Header2 from "../component/Header2";

function Profile() {
  const redirect = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("userid")) {
      redirect("/");
    } else {
      fetchuser();
      fetchappointment();
      document.getElementById('spinner').style.display = "none";
      document.getElementById('spinner1').style.display = "none";
    }
  }, []);
  const [data, setData] = useState({});
  const fetchuser = async () => {
    const result = await axios.get(
      `https://www.rajvicosmeticclinic.com/RajviApi/user_single_get?id=${localStorage.getItem("userid")}`
    );
    console.log(result.data);
    setData(result.data[0]);
  };

  const [appointment, setAppointment] = useState([]);
  const fetchappointment = async () => {
    const res = await axios.get(
      `https://www.rajvicosmeticclinic.com/RajviApi/appointment_single_get?id=${localStorage.getItem(
        "userid"
      )}`
    );
    console.log(res.data);
    setAppointment(res.data);
  }


  return (

    <div>
      <Header2 title="View Profile" />

      <div className="container-fluid">
        <div className="container">
          <div className="row">

            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="bg-light  p-lg-5">
                    <h6 className="d-inline-block text-white text-uppercase bg-primary py-1 px-2">
                      My Profile
                    </h6>
                    <h1 className="mb-4">Edit Profile</h1>
                    <div className='justify-content-center text-center mb-5' id='spinner'>
                      <div class="spinner-border text-danger mt-5"></div>
                    </div>

                    <table className="table">
                      <thead className="table-dark">
                        <tr>
                          <th>ID</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Mobile</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>


                        <tr>
                          <td>{data.id}</td>
                          <td>{data.name}</td>
                          <td>{data.email}</td>
                          <td>{data.mobile}</td>
                          <td>{data.status}</td>
                          <td><a
                            className="btn btn-primary "
                            onClick={() => redirect("/edit_profile/" + data.id)}
                          >Edit Profile</a></td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="bg-light  p-lg-5">
                    <h6 className="d-inline-block text-white text-uppercase bg-primary py-1 px-2">
                      My Appointment
                    </h6>
                    <h1 className="mb-4">My Appointment</h1>
                    <div className='justify-content-center text-center mb-5' id='spinner1'>
                      <div class="spinner-border text-danger mt-5"></div>
                    </div>

                    <table className="table">
                      <thead className="table-dark">
                        <tr>
                          <th>ID</th>
                          <th>User Id</th>
                          <th>App_Date</th>
                          <th>service_id</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>

                        {
                          (appointment.length > 0) ?
                            appointment.map((value, index) => {
                              return (
                                <tr>
                                  <td>{value.id}</td>
                                  <td>{value.userid}</td>
                                  <td>{value.app_Date}</td>

                                  <td>{value.service_id}</td>
                                  <td>{value.status}</td>
                                </tr>
                              );
                            })
                            : <tr>
                              <td>{appointment.message}</td>
                            </tr>

                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>



      <Footer />
      <Helmet>

        <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.bundle.min.js"></script>
        <script src="lib/easing/easing.min.js"></script>
        <script src="lib/waypoints/waypoints.min.js"></script>
        <script src="lib/counterup/counterup.min.js"></script>
        <script src="lib/owlcarousel/owl.carousel.min.js"></script>
        <script src="lib/tempusdominus/js/moment.min.js"></script>
        <script src="lib/tempusdominus/js/moment-timezone.min.js"></script>
        <script src="lib/tempusdominus/js/tempusdominus-bootstrap-4.min.js"></script>

        <script src="mail/jqBootstrapValidation.min.js"></script>
        <script src="mail/contact.js"></script>

        <script src="js/main.js"></script>
      </Helmet>
    </div>

  );
}

export default Profile;
